// extracted by mini-css-extract-plugin
module.exports = {"map":"MiniMap_map__10Brs","wrapper":"MiniMap_wrapper__3uRJp"};